import { BOOTSTRAP_APP } from '../events/types';
import { SET_SESSION, CLEAR_SESSION } from '../session/types';
import { setSession, refreshSession } from '../session/actions';
import LocalStorage from '../utils/storage';
import { UNAUTHORIZED } from '../api/types';
import * as CognitoAuthService from '../services/CognitoAuthService';

const STORAGE_KEY_PREFIX = 'session_';

let isRefreshing = false;

const sessionMiddleware =
  ({ dispatch, getState }) =>
    (next) =>
      (action) => {
        next(action);

        const session = getState().session.current;

        switch (action.type) {
          case BOOTSTRAP_APP: {
            const storedSession = loadSessionFromStorage(LocalStorage);
            if (storedSession) {
              dispatch(setSession(storedSession));
            }
            break;
          }
          case SET_SESSION:
            isRefreshing = false;
            storeSessionInStorage(LocalStorage, action.payload);
            break;
          case CLEAR_SESSION:
            // Reset the refresh latch so a future 401 (after re-login without
            // a full page reload) can retry instead of being silently
            // suppressed by a stale isRefreshing=true.
            isRefreshing = false;
            clearSessionFromStorage(LocalStorage);
            // Centralised logout: every CLEAR_SESSION (sidebar button, forced
            // logout on refresh failure, etc.) revokes the Cognito refresh
            // token server-side. Fire-and-forget — UI is already logged out
            // and a failed revoke shouldn't block. Guarded on
            // isCognitoConfigured so legacy/unconfigured envs don't throw.
            if (CognitoAuthService.isCognitoConfigured()) {
              CognitoAuthService.logout().catch(() => {});
            }
            break;
          case UNAUTHORIZED:
            if (!isRefreshing) {
              isRefreshing = true;
              // Cognito SDK refreshes the access token transparently inside
              // refreshSession; the refreshToken arg is therefore unused. The
              // original `action` is passed through so it can be replayed.
              dispatch(refreshSession(action))
            }
            break;
          default:
            if (!session) {
              const storedSession = loadSessionFromStorage(LocalStorage);
              if (storedSession) {
                dispatch(setSession(storedSession));
              }
            }
            break;
        }
      };

function loadSessionFromStorage(storage) {
  const key = `${STORAGE_KEY_PREFIX}current`;
  return storage.get(key, true);
}

function storeSessionInStorage(storage, session) {
  const key = `${STORAGE_KEY_PREFIX}current`;
  return storage.set(key, session, true);
}

function clearSessionFromStorage(storage) {
  const key = `${STORAGE_KEY_PREFIX}current`;
  storage.remove(key);
}

export default sessionMiddleware;
